export enum TimesheetStatusEnum {
  Approved = 'Approved',
  Revert = 'Revert',
  Open = 'Open',
}

export enum TimesheetStatusColorEnum {
  Approved = 'green',
  Revert = 'red',
  Open = 'grey',
}
